export const plus_circle = () => (
  <path
    d="M12 8v8m-4-4h8m6 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
